import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiCheckBox from '@material-ui/core/Checkbox';
import { Check as CheckIcon } from '@ringcentral/juno-icon';
import { combineClasses, combineProps, omit, styled, useThemeProps, } from '../../../foundation';
import { RcIcon } from '../../Icon';
import { useRcCardContext } from '../Card/CardContext';
import { CardSelectionAreaStyle } from './styles';
import { RcCardSelectionAreaClasses } from './utils';
var SelectionIcon = function (_a) {
    var checked = _a.checked;
    var iconOuterCircle = RcCardSelectionAreaClasses.iconOuterCircle, iconInnerCircle = RcCardSelectionAreaClasses.iconInnerCircle, icon = RcCardSelectionAreaClasses.icon;
    return (React.createElement("div", { className: iconOuterCircle },
        React.createElement("div", { className: iconInnerCircle }, checked && (React.createElement(RcIcon, { className: icon, symbol: CheckIcon, size: "small", color: "neutral.f01" })))));
};
var _RcCardSelectionArea = forwardRef(function (inProps, ref) {
    var props = useThemeProps({
        props: inProps,
        name: 'RcCardSelectionArea',
    });
    var classesProp = props.classes, onFocusVisible = props.onFocusVisible, onBlur = props.onBlur, rest = __rest(props, ["classes", "onFocusVisible", "onBlur"]);
    var setFocusVisible = useRcCardContext().setFocusVisible;
    var events = useMemo(function () {
        return combineProps({
            onFocusVisible: function () { return setFocusVisible(true); },
            onBlur: function () { return setFocusVisible(false); },
        }, {
            onFocusVisible: onFocusVisible,
            onBlur: onBlur,
        });
    }, [onBlur, onFocusVisible, setFocusVisible]);
    var classes = useMemo(function () {
        return omit(combineClasses(RcCardSelectionAreaClasses, classesProp), [
            'iconInnerCircle',
            'iconOuterCircle',
            'icon',
        ]);
    }, [classesProp]);
    return (React.createElement(MuiCheckBox, __assign({}, rest, events, { ref: ref, classes: classes, icon: React.createElement(SelectionIcon, null), checkedIcon: React.createElement(SelectionIcon, { checked: true }), disableRipple: true })));
});
var RcCardSelectionArea = styled(_RcCardSelectionArea)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardSelectionAreaStyle);
RcCardSelectionArea.defaultProps = {};
RcCardSelectionArea.displayName = 'RcCardSelectionArea';
export { RcCardSelectionArea };
var templateObject_1;
